import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentMessage} from "../NfComponentMessage";

/**
 * Wiadomość od komponentu gdy jest właśnie usuwany
 */
export class ComponentRemoved extends NfComponentMessage {
    public constructor(componentId: number|MessageEvent<ComponentRemoved>, browserTabId?: string) {
        super(NfMessageType.ComponentRemoved);
        if(NfMessage.isMessageEvent(componentId)) {
            Object.assign(this, componentId.data);
        } else {
            this.componentId = componentId;
            if(!browserTabId) {
                throw Error('browserTabId jest wymagany');
            }
            this.browserTabId = browserTabId;
        }
    }
    public type = NfMessageType.ComponentRemoved;
    public componentId: number = 0;
    public browserTabId: string = '';
}

NfMessage.creationCallbacks[NfMessageType.ComponentRemoved] = (event) => {
    return new ComponentRemoved(event);
}